import { makeStyles, Typography } from "@material-ui/core";
import ContentComponent from "../ContentComponent";
import React from "react";
import ProfileName from "./ProfileName";
import clsx from "clsx";
import Theme from "../../.themes/common/Theme";

const useStyles = makeStyles((theme: Theme) => ({
    heading: {
        marginBottom: "16px",
    },
    headingWithImage: {
        textAlign: "center",
        [theme.breakpoints.up("md")]: {
            textAlign: "left",
        },
    },
    headingWithoutImage: {
        textAlign: "center",
    },
}));

export type WelcomeTitleProps = {
    hasExclamationMark?: boolean;   
    hasCarImage?: boolean;
    welcomeHeaderPartOneText?: string;

}

export const WelcomeTitle: React.FC<WelcomeTitleProps> = (props: WelcomeTitleProps) => {
    const classes = useStyles();
    // add a comma to the end if not already present
    const welcomeHeaderPartOneText = props.welcomeHeaderPartOneText?.endsWith(",") ? props.welcomeHeaderPartOneText : props.welcomeHeaderPartOneText + ",";
    return (
        <ContentComponent
            titleComponent={<Typography variant='h1' className={clsx(classes.heading, props.hasCarImage ? classes.headingWithImage : classes.headingWithoutImage)}>
                {welcomeHeaderPartOneText}
                <div className='welcome-customer-name data-hj-suppress'>
                    <ProfileName />
                    {props.hasExclamationMark && <span>!</span>}                   
                </div>
            </Typography>}
        />
    );
}

export default WelcomeTitle;
